const Actions = {
  setMatch: data => ({
    type: 'MATCH:SET_DATA',
    payload: data
  })
};

export default Actions;
